<template>
	<div class="assessSuccess">
		<van-nav-bar title="订单详情"  fixed placeholder  left-arrow    @click-left="onClickLeft" />
		 <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
		<van-cell class="project">
			<span class="number">订单编号：{{ order.sn }}</span>
			<!-- <van-card
			
			  title="工程师身份:工程师"
			  :desc="'工程师姓名:'+order.passengerName"
			 
			  :thumb="order.avatar||msg"
			/> -->
			<div class="information">
				<img :src="order.avatar||msg" />
				<div class="information1">
					<span>工程师姓名:{{order.passengerName}}</span>
					<span>工程师身份:工程师</span>
				</div>
			</div>
		</van-cell>
		<van-cell title="企业" :value="order.companyName" />
		<van-cell title="项目" :value="order.projectName" />
		<!-- <van-cell title="服务评价" :value="order.serviceEvaluation"  v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'"/> -->
		<van-cell title="下单时间" :value="order.addTime" />
		<van-cell title="开始时间" :value="order.startTime" v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'"/>
		<van-cell title="结束时间" :value="order.orderEndTime" v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'"/>
		<van-cell title="用车时间" :value="order.useCarTime" />
		<van-cell title="服务时长" :value="parseLen(parseInt(order.servicePeriod/60/60))+':'+parseLen(parseInt(order.servicePeriod/60%60))+':'+parseLen(parseInt(order.servicePeriod%60))" v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'" />
		<van-cell title="服务里程" :value="order.modifyServiceDistanceLabel"   v-show="order.orderStatus == 'ORDER_STATUS-PERFECTION'"/>
		<van-cell title="开始里程表" :value="order.startOrderMile"  v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'||order.orderStatus =='ORDER_STATUS-IN_SERVICE'"/>
		 <van-cell class="project"  v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'||order.orderStatus =='ORDER_STATUS-IN_SERVICE'">
		   <img class="imgtu" :src="startingmileage"   @click="startingmileageimg()" />
		 </van-cell>
		<van-cell title="结束里程表" :value="order.endOrderMile"   v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'"/>
		 <van-cell class="project"  v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'">
	        <img class="imgtu"  :src="endmileage"  @click="endmileageimg()"/>
	     </van-cell>
		<van-collapse v-model="activeNames">
			<van-collapse-item title="附加费用" name="2" v-if="order.orderStatus == 'ORDER_STATUS-PERFECTION'||order.orderStatus =='ORDER_STATUS-IN_SERVICE'">
				<van-cell title="总费用" :value="order.orderCostImageVo.totalCost+this.yuan" />
				<van-cell title="高速费" :value="order.orderCostImageVo.highSpeedCost+this.yuan" />
				<van-cell title="停车费" :value="order.orderCostImageVo.stoppingCost+this.yuan" />
				<van-cell title="其他费用" :value="order.orderCostImageVo.otherCost+this.yuan" />
				<van-cell class="project">
					<p>已提交图片</p>
					<div v-for="(item, index) in imgelist" :key="index">
					    <img class="imgtu"  :src="item" @click="sceneImg(imgelist,index)" />
					</div>
				</van-cell>
			</van-collapse-item>
			<van-collapse-item title="用车地点" name="1">
				<div class="assess-p">
					<img src="../../assets/qidian.png" />
					<p>{{ order.upAddress }}</p>
				</div>
				<div class="assess-p" v-for="(item, index) in order.orderPassPoints" :key="index">
					<img src="../../assets/jing.png" />
					<p>{{ item.address }}</p>
				</div>
				<div class="assess-p">
					<img src="../../assets/zhongdian.png" />
					<p>{{ order.downAddress }}</p>
				</div>
			</van-collapse-item>
			<!-- <van-collapse-item title="签到记录" name="2" v-show="order.orderStatus == 'ORDER_STATUS-PERFECTION'">
	  </van-collapse-item> -->
		</van-collapse> 
	</van-pull-refresh>
	</div>
</template>
<script>
	import {
		Cell,
		Collapse,
		CollapseItem,
		NavBar,
		
		ImagePreview,
		PullRefresh
		// Image as VanImage,
		// ImagePreview 
	} from "vant";
	export default {
		name: "allorderslist_driver",
		components: {
			"van-nav-bar": NavBar,
			"van-cell": Cell,
			// "van-card":Card,
			"van-collapse": Collapse,
			"van-collapse-item": CollapseItem,
			"van-pull-refresh":PullRefresh
			// "van-image": VanImage,
			 // [ImagePreview.Component.name]: ImagePreview.Component,

		},
		data() {
			return {
				accountid: localStorage.getItem("accountUid"),
				sn: "",
				msg:require("@/assets/iconss.png"),
				order: "",
				yuan: "/元",
				activeNames: ['1'],
				returtlist: "",
				imgelist:"",
				startingmileage:"",
				endmileage:"",
				instance_before:'',
				instance_after:'',
			   refreshing: false,
				
			};
		},
		created() {
			this.sn=this.$route.query.sn||localStorage.getItem("orderSn")
			this.returtlist=this.$route.query.returtlist
			console.log(this.sn)
			console.log(this.returtlist)
		},
		mounted() {
			this.orderDetail();
		},
		 //在路由离开的时候，关闭预览的图片
		  // beforeRouteLeave(to,from,next){
		  //     if(this.active_ == 0){
		  //       this.instance_before.close();
		  //     }else{
		  //       this.instance_after.close();
		  //     }
		  //     next();
		  //   },
		methods: {
			//返回
			onClickLeft() {
				if (this.returtlist == "" || this.returtlist == null) {
					window.open("app:/#/finish");
				} else {
					this.$router.back();
				}
			},
			//转化时分秒
			parseLen(v){
			  return v>9 ?v:"0"+v;
			},
			//费用图片放大 
			sceneImg(images,index) {
			      ImagePreview({
			        images:this.imgelist, //需要预览的图片 URL 数组
			        showIndex:true, //是否显示页码
			        loop:false, //是否开启循环播放
			        startPosition:index //图片预览起始位置索引
			      })
			    },
				
			// 开始里程图片放大
			startingmileageimg(){
			        this.instance_before = ImagePreview({
			          images: [this.startingmileage],
			        });
			      },
			
			endmileageimg(){
			  this.instance_before=ImagePreview({
				  images:[this.endmileage], //需要预览的图片 URL 数组
				  
				})
			},
			// 下拉刷新
			onRefresh() {
			  this.orderDetail();
			  this.refreshing = false;
			},
			// 结束里程图片放大
			// 订单详情
			orderDetail() {
				this.$axios
					.get(
						`/vedm/orderCommonApp/getOrderDetail/${this.sn}/${this.accountid}`, {
							headers: {
								Authorization: localStorage.getItem("token"), //token换成从缓存获取
							},
						}
					)
					.then((res) => {
						 console.log(res, "列表");
						this.order = res.data.data;
						this.startingmileage=res.data.data.startOrderImage
						this.endmileage=res.data.data.endOrderImage
						this.imgelist=res.data.data.orderCostImageVo.orderCostImageList
						var imglisttu=[]
						this.imgelist.forEach(function(item){
							// console.log(item,"22323")
							var imgtu=item
							imglisttu.push(imgtu)
							
						})
						this.imgelist=imglisttu
						// ImagePreview.push(this.imgelist)
					}).catch(function(error) {
						console.log(error)
						window.app.showReLoginDialog()
					});;
			},

		}

	};
</script>

<style scoped lang="less">
	.assessSuccess {
		background: rgba(247, 247, 247, 1);
        .imgtu{
			width: 90px;
			height: 90px;
			margin-left: 8px;
			margin-top: 8px;
			
			
			}
			
		.project {
			align-items: center;

			.information {
				width: 100%;
				overflow: hidden;
				display: flex;
			}

			.information img {
				width: 50px;
				height: 50px;
				border-radius: 50%;
				float: left;
				margin-left: 0.3rem;
				margin-top: 0.3rem;
			}

		

			.information1 span {
				 width: 200px;
				 height: 20px;
                 display: block;
				 float: left;
				 margin-top: 5px;
				 margin-left: 10px;
				
				 

			}

			.number {
				display: block;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(158, 160, 165, 1);
			}

			.name {
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: rgba(33, 37, 41, 1);
				margin: 0;
			}

			.tag {
				margin-left: 10px;
			}

			.tagRight {
				background: rgba(255, 149, 0, 0.1);
				border-radius: 2px;
				border: 1px solid rgba(255, 149, 0, 1);
				font-size: 11px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(255, 149, 0, 1);
				margin-right: 5px;
			}

			.spanRight {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 37, 41, 1);
			}
		}

		img {
			width: 30px;
			height: 30px;
			float: left;
			
		}

		.assess-p p {
			margin-top: 10px;
			padding-top: 5px;
		}

		.happening {
			width: 375px;
			background: rgba(255, 255, 255, 1);
			padding: 15px;
			margin-bottom: 12px;

			p {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				margin: 0;
				margin-bottom: 10px;
				line-height: 25px;
			}

			span {
				display: block;
				width: 100%;
				height: 80px;
				background: #f8f6f9;
				font-size: 14px;
				border-radius: 10px;
				padding-top: 10px;
				text-indent: 1em;
			}


			.div {
				width: 104px;
				height: 28px;
				line-height: 28px;
				text-align: center;
				border-radius: 14px;
				border: 1px solid rgba(232, 233, 235, 1);
				margin: 0 auto;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 37, 41, 1);
			}

			.options {
				width: 345px;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin-top: 24px;
			}

			.item {
				height: 28px;
				line-height: 28px;
				text-align: center;
				border-radius: 6px;
				padding: 0 20px;
				border: 1px solid rgba(232, 233, 235, 1);
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(98, 104, 112, 1);
			}
		}
	}
</style>
